import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import CartFreeShipping from 'Component/CartFreeShipping';
import Image from 'Component/Image';
import Link from 'Component/Link';
import Popup from 'Component/Popup';
import ProductListBySkus from 'Component/ProductListBySkus';
import { CART_URL } from 'Route/CartPage/CartPage.config';
import { PopupCartType } from 'Type/Cart.type';
import { ItemType } from 'Type/ProductList.type';
import { formatPrice } from 'Util/Price';

import { CART_POPUP_ID } from './CartPopup.config';

import './CartPopup.style';

/** @namespace PeggysagePwa/Component/CartPopup/Component */
export class CartPopupComponent extends PureComponent {
    static propTypes = {
        payload: PropTypes.shape({
            cart: PopupCartType,
            products: PropTypes.arrayOf(PropTypes.shape({
                sku: PropTypes.string,
                quantity: PropTypes.number
            }))
        }).isRequired,
        currencyCode: PropTypes.string,
        addedProducts: PropTypes.arrayOf(PropTypes.shape({
            product: ItemType,
            quantity: PropTypes.number
        })).isRequired,
        onViewCartButtonClick: PropTypes.func.isRequired
    };

    static defaultProps = {
        currencyCode: null
    };

    renderPriceLine(price, currencyCode) {
        const { currencyCode: defaultCurrency } = this.props;

        const currency = currencyCode || defaultCurrency;

        return formatPrice(price, currency);
    }

    renderProduct(item, index) {
        const {
            product: {
                name,
                thumbnail
            },
            quantity
        } = item;

        return (
            <div block="CartPopup" elem="Product" key={ index }>
                <div block="CartPopup" elem="ProductImage">
                    <Image
                      src={ thumbnail?.url }
                      ratio="custom"
                      mix={ {
                          block: 'CartPopup',
                          elem: 'ProductThumbnail',
                          mods: { isPlaceholder: !thumbnail?.url }
                      } }
                      isPlaceholder={ !thumbnail?.url }
                      alt={ name }
                    />
                </div>
                <div block="CartPopup" elem="ProductContent">
                    <div block="CartPopup" elem="ProductTitle">
                        <span>{ name }</span>
                        { ' ' }
                        { __('has been added to your cart') }
                    </div>
                    <div block="CartPopup" elem="ProductQuantity">
                        { __('Quantity: %s', quantity) }
                    </div>
                </div>
            </div>
        );
    }

    renderProducts() {
        const { addedProducts } = this.props;

        if (!addedProducts) {
            return null;
        }

        return (
            <div block="CartPopup" elem="Products">
                { addedProducts.map(this.renderProduct.bind(this)) }
            </div>
        );
    }

    renderTotals() {
        const { payload: { cart: { prices: { subtotal_including_tax: { value: total = 0, currency } } } } } = this.props;

        return (
            <dl
              block="CartPopup"
              elem="Total"
            >
                <dt>{ `${__('Products total')} ${__('Incl. Tax')}` }</dt>
                <dd>
                    { this.renderPriceLine(total, currency) }
                </dd>
            </dl>
        );
    }

    renderFreeShipping() {
        return (
            <div block="CartPopup" elem="FreeShipping">
                <CartFreeShipping />
            </div>
        );
    }

    renderSummary() {
        const { payload: { cart: { total_quantity } }, onViewCartButtonClick } = this.props;

        const totalQuantity = total_quantity > 1
            ? __('There are %s products in your cart', total_quantity)
            : __('There is 1 product in your cart');

        return (
            <div block="CartPopup" elem="Summary">
                <p block="CartPopup" elem="TotalQuantity">
                    { totalQuantity }
                </p>
                { this.renderTotals() }
                { this.renderFreeShipping() }
                <div block="CartPopup" elem="Actions">
                    <Link
                      block="CartPopup"
                      elem="CartButton"
                      mix={ { block: 'Button' } }
                      to={ CART_URL }
                      onClick={ onViewCartButtonClick }
                    >
                        { __('View cart') }
                    </Link>
                </div>
            </div>
        );
    }

    renderCrossProducts() {
        const { payload: { cart: { cross_product_skus: productsSkuArray } } } = this.props;

        if (!productsSkuArray || !productsSkuArray.length) {
            return null;
        }

        return (
            <div block="CartPopup" elem="CrossSell">
                <div block="CartPopup" elem="CrossSellTitle">
                    { __('Les indispensables') }
                </div>
                <div block="CartPopup" elem="CrossSellContent">
                    <ProductListBySkus
                      productsCount={ productsSkuArray.length }
                      productsPerPage={ productsSkuArray.length }
                      productsSkuArray={ productsSkuArray }
                    />
                </div>
            </div>
        );
    }

    renderContent() {
        const { payload: { cart } } = this.props;

        if (!cart) {
            return null;
        }

        return (
            <>
                { this.renderProducts() }
                { this.renderSummary() }
                { this.renderCrossProducts() }
            </>
        );
    }

    render() {
        return (
            <Popup
              id={ CART_POPUP_ID }
              clickOutside={ false }
              title=""
              mix={ { block: 'CartPopup' } }
            >
                { this.renderContent() }
            </Popup>
        );
    }
}

export default CartPopupComponent;
